import { render } from "./OrgSettingsToggleRow.vue?vue&type=template&id=7c8c83c8"
import script from "./OrgSettingsToggleRow.vue?vue&type=script&lang=js"
export * from "./OrgSettingsToggleRow.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__